import { useState } from "react";
import { useAuthControllerRegister } from "../utils/api/kolektifOluşumAPI";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const Register = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const { mutate: registerMutation } = useAuthControllerRegister({
    mutation: {
      onSuccess: () => {
        navigate("/giris-yap");
      },
      onError: (error: any) => {
        setError(
          error.response?.data?.message || "Kayıt olurken bir hata oluştu",
        );
      },
    },
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    registerMutation({ data: { name, email, password } });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a] py-12 px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          duration: 0.8,
          ease: [0.23, 1, 0.32, 1],
        }}
        className="max-w-md w-full space-y-8 bg-[#111111] border border-white/10 rounded-xl p-8 backdrop-blur-sm"
      >
        <motion.h2
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="text-center text-3xl font-extrabold text-white"
        >
          Üye Ol
        </motion.h2>

        <motion.form
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.7, delay: 0.4 }}
          className="mt-8 space-y-6"
          onSubmit={handleSubmit}
        >
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="name" className="sr-only">
                Ad Soyad
              </label>
              <input
                id="name"
                name="name"
                type="text"
                autoComplete="name"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="appearance-none rounded-t-lg relative block w-full px-3 py-2 border border-white/10 bg-white/5 placeholder-gray-400 text-white focus:outline-none focus:ring-blue-500/50 focus:border-blue-500/50 focus:z-10 sm:text-sm transition-all duration-300"
                placeholder="Ad Soyad"
              />
            </div>
            <div>
              <label htmlFor="email" className="sr-only">
                Email
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="appearance-none relative block w-full px-3 py-2 border border-white/10 bg-white/5 placeholder-gray-400 text-white focus:outline-none focus:ring-blue-500/50 focus:border-blue-500/50 focus:z-10 sm:text-sm transition-all duration-300"
                placeholder="Email adresi"
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Şifre
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="new-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="appearance-none rounded-b-lg relative block w-full px-3 py-2 border border-white/10 bg-white/5 placeholder-gray-400 text-white focus:outline-none focus:ring-blue-500/50 focus:border-blue-500/50 focus:z-10 sm:text-sm transition-all duration-300"
                placeholder="Şifre"
                minLength={6}
              />
            </div>
          </div>

          {error && (
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4 }}
              className="text-red-500 text-sm text-center bg-red-500/10 border border-red-500/20 rounded-lg py-2"
            >
              {error}
            </motion.div>
          )}

          <div className="mt-6">
            <button
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-lg text-white bg-blue-500/10 border-blue-500/20 hover:bg-blue-500/20 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500/50 transition-all duration-300"
            >
              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                <svg
                  className="h-5 w-5 text-blue-500/40 group-hover:text-blue-500/50 transition-colors duration-300"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M8 9a3 3 0 100-6 3 3 0 000 6zM8 11a6 6 0 016 6H2a6 6 0 016-6zM16 7a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V7z" />
                </svg>
              </span>
              Üye Ol
            </button>
          </div>
        </motion.form>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="text-center"
        >
          <p className="text-sm text-gray-400">
            Zaten hesabın var mı?{" "}
            <Link
              to="/giris-yap"
              className="font-medium text-blue-400 hover:text-blue-300 transition-colors relative group"
            >
              Giriş Yap
              <span className="absolute -bottom-0.5 left-0 w-0 h-[1px] bg-blue-400 group-hover:w-full transition-all duration-500"></span>
            </Link>
          </p>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Register;
